export default "__VITE_ASSET__d9e5bf8f__"